/**
 * Optimization configuration for line items
 *
 * Presence/absence of the object indicates whether optimization is enabled;
 * optimization_type is optional within it and defaults to CVR when omitted.
 */
// --- Enums ---
export var OptimizationMode;
(function (OptimizationMode) {
    OptimizationMode["DISABLED"] = "DISABLED";
    OptimizationMode["ENABLED"] = "ENABLED";
})(OptimizationMode || (OptimizationMode = {}));
export var OptimizationType;
(function (OptimizationType) {
    OptimizationType["SITE_VISITS"] = "CVR";
    OptimizationType["REACH"] = "REACH";
    OptimizationType["VIDEO_COMPLETION_RATE"] = "VCR";
    OptimizationType["CLICK_THROUGH_RATE"] = "CTR";
    OptimizationType["LISTEN_THROUGH_RATE"] = "LTR";
})(OptimizationType || (OptimizationType = {}));
// --- Conversion Functions ---
export function serviceOptimizationToOptimization(svc) {
    if (!svc) {
        return { mode: OptimizationMode.DISABLED };
    }
    const details = svc.outcomes_experiment_details;
    return {
        mode: OptimizationMode.ENABLED,
        trackingPixelId: "",
        optimizationType: svc.optimization_type,
        ...(details && {
            outcomesExperimentDetails: {
                experimentId: details.experiment_id || "",
                controlVariantId: details.control_variant_id || "",
                holdoutVariantId: details.holdout_variant_id || ""
            }
        })
    };
}
export function optimizationToServiceOptimization(opt) {
    if (opt.mode === OptimizationMode.DISABLED) {
        return undefined;
    }
    // outcomesExperimentDetails is deliberately not serialized; the server keeps its stored value.
    return opt.optimizationType ? { optimization_type: opt.optimizationType } : {};
}
// --- Type Guards & Helpers ---
export function isOptimizationEnabled(opt) {
    return opt.mode === OptimizationMode.ENABLED;
}
//# sourceMappingURL=optimization.js.map